export function handleDownload(downloadUrl, fileName, targetElement = '') {
  if (!downloadUrl) {
    console.error('No download URL provided');
    return;
  }

  // If you want the link to be clicked in a certain place,
  // Pass in the id of the div to targetElement
  // Otherwise it will just be attached to the body
  let target = document.body;
  if (targetElement) {
    target = document.getElementById(targetElement);
    if (!target) {
      target = document.body; // fallback to body if target not found
    }
  }
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = fileName;
  target.appendChild(link);
  link.click();
  target.removeChild(link);
}
